import { Checkbox, Flex, Spacing, Text } from '@billy/design-system'
import { ChangeEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface AddressExemptionCheckboxProps {
  checked?: boolean
  onChange: (isChecked: boolean) => void
}

export const AddressExemptionCheckbox = ({
  checked = false,
  onChange,
}: AddressExemptionCheckboxProps): ReactElement => {
  const { t } = useTranslation()

  const handleCheckboxChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event.currentTarget.checked)
    },
    [onChange],
  )

  return (
    <Flex flexDirection="column" gap={Spacing.S8}>
      <Styled.CheckboxContainer>
        <Checkbox checked={checked} onChange={handleCheckboxChange}>
          {t('customer_modal.form.address_exemption_checkbox.label')}
        </Checkbox>
      </Styled.CheckboxContainer>
      <Text colorVariant="secondary" variant="bodySM">
        {t('customer_modal.form.address_exemption_checkbox.description')}
      </Text>
    </Flex>
  )
}
